import { Box, styled } from '@mui/material'

export const StyledAlertContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '496px',
  position: 'fixed',
  top: 8,
  zIndex: 9999,
  left: 0,
  right: 0,
  margin: 'auto',
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
  '&>div': {
    boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.2)',
  },
}))
